/**
 * 상세 수수료율 목록 표시용 이메일.
 * 레거시 API는 `userEmail`, 일부 응답은 `email`을 사용한다.
 */
export const getDetailFeeGroupEmail = (row: {
  userEmail?: string | null;
  email?: string | null;
}): string => row.userEmail || row.email || '-';
